(() => {
  // Close the mobile menu when a link is tapped or Escape is pressed.
  document.querySelectorAll('[data-drawer]').forEach((drawer) => {
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('a')) drawer.removeAttribute('open');
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') drawer.removeAttribute('open');
    });
  });

  // Cart page: submit the form when a quantity changes.
  document.querySelectorAll('[data-auto-submit]').forEach((input) => {
    input.addEventListener('change', () => input.form.submit());
  });

  function formatMoney(cents, format) {
    const value = (Number(cents) / 100);
    const withDelims = (n, decimals, thousands, decimal) => {
      const [whole, frac] = n.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  // Product page: pick the variant that matches the selected options.
  document.querySelectorAll('[data-product]').forEach((root) => {
    const variantsEl = root.querySelector('[data-variants]');
    if (!variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent);
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const addBtn = root.querySelector('[data-add]');
    const fieldsets = [...root.querySelectorAll('[data-option]')];

    const update = () => {
      const selected = fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
      fieldsets.forEach((fs, i) => {
        const label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = selected[i] || '';
      });

      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      let html = formatMoney(variant.price, moneyFormat);
      if (variant.compare_at_price > variant.price) {
        html += ` <s class="price__compare">${formatMoney(variant.compare_at_price, moneyFormat)}</s>`;
      }
      priceEl.innerHTML = html;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    fieldsets.forEach((fs) => fs.addEventListener('change', update));

    root.querySelectorAll('[data-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
      });
    });
  });
})();
